import { Box, Container, Paper, Typography, Button } from "@mui/material";
import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from "@mui/icons-material";

export default function SimplePartInstruction({ currentPart, partStyle, onNext, onPrevious, isFirstPart }) {
  return (
    <Container maxWidth="xl">
      <Paper
        elevation={3}
        sx={{ p: 4, borderRadius: 2, mt: 15, textAlign: "center", ...partStyle }}
      >
        <Typography variant="h2" component="h1" sx={{ mb: 15, fontWeight: 600 }}>
          Part {currentPart.partNumber}
        </Typography>

        {/* Navigation Buttons */}
        <Box display="flex" justifyContent="space-between" mt={4} gap={2}>
          <Button
            variant="outlined"
            onClick={onPrevious}
            disabled={isFirstPart}
            size="large"
            startIcon={<ArrowBackIcon />}
          >
            Previous
          </Button>
          <Button
            variant="contained"
            onClick={onNext}
            size="large"
            endIcon={<ArrowForwardIcon />}
          >
            Next
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
